/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CdpHelper, useSitecore } from '@sitecore-content-sdk/nextjs';
import { useEffect } from 'react';
import { pageView } from '@sitecore-content-sdk/events';
import config from 'sitecore.config';
/**
 * This is the CDP page view component.
 * See Sitecore Content SDK documentation for details.
 * https://www.npmjs.com/package/@sitecore-content-sdk/events
 */ const CdpPageView = ()=>{
    const { page: { layout, siteName, mode } } = useSitecore();
    const { route, context } = layout.sitecore;
    /**
   * Determines if the page view events should be turned off.
   * IMPORTANT: You should implement based on your cookie consent management solution of choice.
   * By default it is disabled in development mode
   */ const disabled = ()=>{
        return "production" === 'development';
    };
    useEffect(()=>{
        // Do not create events in editing or preview mode or if missing route data
        if (!mode.isNormal || !route?.itemId) {
            return;
        }
        // Do not create events if disabled (e.g. we don't have consent)
        if (disabled()) {
            return;
        }
        const language = route.itemLanguage || config.defaultLanguage;
        const scope = config.personalize?.scope;
        const pageVariantId = CdpHelper.getPageVariantId(route.itemId, language, context.variantId, scope);
        // there can be cases where Events are not initialized which are expected to reject
        pageView({
            channel: 'WEB',
            currency: 'USD',
            page: route.name,
            pageVariantId,
            language
        }).catch((e)=>console.debug(e));
    }, [
        mode,
        route,
        context.variantId,
        siteName
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
export default CdpPageView;
